module.exports = __webpack_public_path__ + "media/images/badgerart02-e74d0a9b33ccc410966bfd8b16ebcedf.png";